import { Image, Nav, Tab, Table } from "react-bootstrap";
import { Button, Col, Container, Form, FormGroup, Input, Label, Row, Badge } from "reactstrap";
import { Card, } from "react-bootstrap";
import ItemWrapper from "./ItemWrapper";
import img1 from "../../../../../src/assetsNew/1.jpg";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { backendbaseUrl } from "../../../../Utils/baseUrl";
import { useParams, useLocation } from "react-router-dom";
import axiosInstance from "../../../../Utils/axiosInstance";
import { toast } from "react-toastify";
import { isString, toInteger, toNumber } from "lodash";
import { Users, ArrowUpRight } from 'lucide-react';
import { useNavigate } from "react-router-dom";
import { ArrowUpCircle, CheckCircle, Clock, XCircle } from "react-feather";
import { FaEnvelope, FaPhoneAlt, FaCalendarAlt, FaShieldAlt, FaUserPlus, FaBolt } from "react-icons/fa"
import { Success, None } from './../../../../Utils/Constants/index';
import ToggleModalBody from "../../../../Components/UiKits/Modal/ToggleModal/ToggleModalBody";
interface PlanData {
    planName: string;
    PurchaseDate: string;
    ExpiryDate: string;
    DurationInDays: number;
    Total: string;
}
interface PricingResponse {
    data: {
        remaining_days: number;
        single_user_cost: string
        single_user_per_day_cost: number;
        currency: string
        final_cost: number;
        price_of_the_plan: {
            source: string;
            parsedValue: number;
        };
        max_user: number;
        days: number;
        total_cost: number;
    };
}



export interface PlanCurrentAndSuggestions {
    id: string;
    selected_apps: string[];
    ordering_id: number;
    created_at: number;
    retrieved_at: number | null;
    name: string;
    description: string;
    price: string;
    days: number;
    max_users: number;
    visibility: boolean;
    custom_plan: boolean;
    country: string;
}

export interface Recommendations {
    upgrade_plans: PlanCurrentAndSuggestions[];
    downgrade_plans: PlanCurrentAndSuggestions[];
}

export interface PlanInterface {
    current_plan: PlanCurrentAndSuggestions;
    recommendations: Recommendations;
}

export interface CompanyDetailsData {
    id: string;
    name: string;
    email: string;
    phone_number: string;
    country: string;
    is_blocked: boolean;
    created_at: number;
}

interface Plan {
    id: string;
    name: string;
    price: string;
    duration: string;
    features: string[];
    maxUsers: number;
    currentUsers: number;
    status: "active" | "expired" | "upcoming";
    startDate: string;
    endDate: string;
}
interface organizationType {
    name: string;
    email: string;
    phoneNumber: string;
    defaultCountry: string;
    defaultCurrency: string;
    // planActive: boolean;
    // blocked: boolean;
}

interface UsersDataType {
    name: string;
    email: string;
    phoneNumber: string;
    active: boolean;
    user: string;
}

interface PlanDetails {
    id: string;
    organization: {
        id: string;
        name: string;
        email: string;
        is_plan_active: boolean;
    };
    plan: {
        id: string;
        name: string;
        days: number;
        max_users: number;
    };
    purchase_date: string;         // e.g., "13-05-2025"
    expiry_date: string;           // e.g., "13-05-2025 "
    users_under_plan: string;      // e.g., "1/10"
    is_online_purchase: boolean;
    admin_approved: string;        // e.g., "approved"
    created_at: number;            // Unix timestamp
    is_plan_active: boolean;
    used_user: number;

}


interface AppsDetails {
    selected_apps: string[];

}


interface PurchaseHistory {
    name: string;
    startDate: string;
    expiryDate: string;
    isOnlinePurchase: boolean;
}
interface UserProfileType {
    ordering_id: number;
    created_at: number;
    retrieved_at: number | null;
    name: string;
    email: string;
    phone_number: string;
    is_plan_active: boolean;
    is_blocked: boolean;
    country: string;
    default_currency: string;
    companyId: string;
}

const CompanyUserUpgrade = () => {
    const [state, setState] = useState(false);
    const { id } = useParams();
    const navigate = useNavigate();
    const [planData, setPlanData] = useState<PlanData[]>([]);
    const [organizations, setorganizations] = useState<organizationType[]>([]);
    const [users, setUsers] = useState<UsersDataType[]>([]);
    const [history, setHistory] = useState<PurchaseHistory[]>([]);

    const [companyInfo, setCompanyInfo] = useState<any>(false);

    const getPlanStatus = (startDate: string, expiryDate: string): string => {
        const currentDate = new Date();
        const start = new Date(startDate);
        const expiry = new Date(expiryDate);

        return currentDate >= start && currentDate <= expiry ? "Active" : "Expired";
    };

    const blockedHandler: any = async () => {
        try {
            const response = await axiosInstance.post(
                `${backendbaseUrl}/company/block-organization/${id}/`
            );

            console.log(response.data);
        } catch (error: any) { }
    };

    const getRandomColor = (str: string) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        const color = `hsl(${hash % 360}, 70%, 60%)`; // Generates a unique HSL color
        return color;
    };

    const getPlanColors = (plans: PlanData[]) => {
        const colorMap: Record<string, string> = {};

        plans.forEach((plan) => {
            if (!colorMap[plan.planName]) {
                colorMap[plan.planName] = getRandomColor(plan.planName);
            }
        });

        return colorMap;
    };


    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const usersCountParams = searchParams.get("users");
    const [planColors, setPlanColors] = useState<Record<string, string>>({});

    const [pricingResponseData, setPricingResponseData] = useState<PricingResponse | null>(null)


    useEffect(() => {


        const fetchPriceBreakDown = async () => {
            try {

                const response = await axiosInstance.post(
                    `${backendbaseUrl}/company/user-upgrade/${id}/custom-user/`, { "user_count": toInteger(usersCountParams) }
                )

                if (response.status == 200) {
                    console.log(response.data, "-0---------------------->")
                    setPricingResponseData(response.data)
                }

            }
            catch (error) {

                toast.error(isString(error))

            }

        }

        fetchPriceBreakDown()

    }, [])



    useEffect(() => {
        if (planData.length > 0) {
            setPlanColors(getPlanColors(planData));
        }
    }, [planData]);


    const [purchaseHistoryData, setPurchaseHistoryData] = useState([])
    useEffect(() => {

        const fetchpurchaseHistory = async () => {
            try {

                const response = await axiosInstance.get(
                    `${backendbaseUrl}/company/payments/history/${id}`
                )

                if (response.status == 200) {
                    setPurchaseHistoryData(response.data)
                    // console.log("data,", response.data)
                    // console.log("fetchpurchaseHistory", purchaseHistoryData)
                }

            }
            catch (error) {

                toast.error(isString(error))

            }

        }

        fetchpurchaseHistory()

    }, [])





    const [plansuggestions, setplansuggestion] = useState<PlanInterface | null>(null)
    const [updatesuggestion, setUpdatesuggestions] = useState<number>(0)
    useEffect(() => {

        const fetchPlanSuggestions = async () => {
            try {

                const response = await axiosInstance.get(
                    `${backendbaseUrl}/plans/detail/${id}`
                )

                if (response.status === 200) {
                    setplansuggestion(response.data)
                }

            }
            catch (error) {

                toast.error(isString(error))

            }

        }

        fetchPlanSuggestions()

    }, [updatesuggestion, id])





    const [currentPlan, setCurrentPlan] = useState<Plan>({
        id: "plan-1",
        name: "Business Pro",
        price: "$99/month",
        duration: "Monthly",
        features: [
            "50 users included",
            "Advanced analytics",
            "Priority support",
            "API access",
            "Custom branding"
        ],
        maxUsers: 50,
        currentUsers: 32,
        status: "active",
        startDate: "2023-10-01",
        endDate: "2023-11-01"
    });

    // Dummy data for available plans
    const [availablePlans, setAvailablePlans] = useState<Plan[]>([
        {
            id: "plan-2",
            name: "Starter",
            price: "$29/month",
            duration: "Monthly",
            features: [
                "10 users included",
                "Basic analytics",
                "Email support",
                "Standard features"
            ],
            maxUsers: 10,
            currentUsers: 0,
            status: "upcoming",
            startDate: "",
            endDate: ""
        },
        {
            id: "plan-3",
            name: "Enterprise",
            price: "$299/month",
            duration: "Monthly",
            features: [
                "Unlimited users",
                "Advanced analytics",
                "24/7 support",
                "Dedicated account manager",
                "Custom integrations"
            ],
            maxUsers: 999,
            currentUsers: 0,
            status: "upcoming",
            startDate: "",
            endDate: ""
        },
        {
            id: "plan-4",
            name: "Business Pro (Annual)",
            price: "$949/year",
            duration: "Annual",
            features: [
                "50 users included",
                "Advanced analytics",
                "Priority support",
                "API access",
                "Custom branding",
                "2 months free"
            ],
            maxUsers: 50,
            currentUsers: 0,
            status: "upcoming",
            startDate: "",
            endDate: ""
        }
    ]);

    const handleUpgradeClick = (planId: string) => {
        // In a real app, this would navigate to a checkout page
        alert(`Upgrading to plan ${planId}. This would navigate to checkout in a real app.`);
        // navigate(`/upgrade/${planId}`);
    };

    const renderStatusBadge = (status: boolean) => {
        switch (status) {
            case true:
                return <Badge bg="success" className="d-flex align-items-center gap-1"><CheckCircle size={14} /> Active</Badge>;
            case false:
                return <Badge bg="danger" className="d-flex align-items-center gap-1"><XCircle size={14} /> Expired</Badge>;
            default:
                return <Badge bg="warning" className="d-flex align-items-center gap-1"><Clock size={14} /> Upcoming</Badge>;
        }
    };

    const renderUserProgress = (current: number, max: number) => {
        const percentage = Math.min(100, (current / max) * 100);
        return (
            <div className="mt-2">
                <div className="d-flex justify-content-between mb-1">
                    <small>{current} of {max} users</small>
                    <small>{percentage.toFixed(0)}%</small>
                </div>
                <div className="progress" style={{ height: "8px" }}>
                    <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: `${percentage}%` }}
                        aria-valuenow={percentage}
                        aria-valuemin={0}
                        aria-valuemax={100}
                    ></div>
                </div>
            </div>
        );
    };



    const [loginhistory, setLoginhistory] = useState([])
    useEffect(() => {

        const fetchloginhistory = async () => {
            try {

                const response = await axiosInstance.get(
                    `${backendbaseUrl}/company/company-users/history/${id}`
                )

                if (response.status == 200) {
                    setLoginhistory(response.data)
                    console.log("data,", response.data)
                    // console.log("fetchpurchaseHistory", purchaseHistoryData)
                }

            }
            catch (error) {

                toast.error(isString(error))

            }

        }

        fetchloginhistory()

    }, [])

    const checkPaymentStatus = async () => {
        try {
            // const id = "1f95379d-dcd9-41ab-af1e-b6d2921f4753";

            const response = await axiosInstance.get(
                `${backendbaseUrl}/company/organization/${id}`
            );

            const currentPlan = response.data.current_plan;
            const organizationDetails = response.data.organization_details;
            const userData = response.data.users;
            const history = response.data.purchase_history;
            const companys = response.data;
            const companyId = response.data.id

            // if (!currentPlan) return;

            const formattedPlan: PlanData[] = [
                {
                    planName: currentPlan.plan_name || "Unknown Plan",
                    PurchaseDate: currentPlan.purchase_date || "N/A",
                    ExpiryDate: currentPlan.expiry_date || "N/A",
                    DurationInDays: currentPlan.remaining_days || 0,
                    Total: `${currentPlan.total_users || 0}/${currentPlan.max_users || 0
                        }`,
                },
            ];

            const formattedOrganizations: organizationType[] = [
                {
                    name: organizationDetails.name || "Unknown Org",
                    email: organizationDetails.email || "N/A",
                    phoneNumber: organizationDetails.phone_number || "N/A",
                    defaultCountry: organizationDetails.default_country || "N/A",
                    defaultCurrency: organizationDetails.default_currency || "N/A",
                    // planActive: organizationDetails.is_plan_active || "N/A",
                    // blocked: organizationDetails.is_blocked || "N/A",
                },
            ];

            const formattedUsers: UsersDataType[] = userData.map((user: any) => ({
                name: user.name || "N/A",
                email: user.email || "N/A",
                phoneNumber: user.phone_number || "N/A",
                active: user.is_active ?? false,
                user: user.user_type || "N/A",
            }));

            const formattedHistory: PurchaseHistory[] = history.map((item: any) => ({
                name: item.plan_name || "N/A",
                startDate: item.start_date || "N/A",
                expiryDate: item.expiry_date || "N/A",
                isOnlinePurchase: item.is_online_purchase ?? false,
            }));

            const companysData: UserProfileType = {
                ordering_id: companys.id,
                created_at: companys.created_at,
                retrieved_at: companys.retrieved_at,
                name: companys.name,
                email: companys.email,
                phone_number: companys.phone_number,
                is_plan_active: companys.is_plan_active,
                is_blocked: companys.is_blocked,
                country: companys.country,
                default_currency: companys.default_currency,
                companyId: companyId
            };
            console.log("companysData", companysData, "companysData")
            setPlanData(formattedPlan);
            setorganizations(formattedOrganizations);
            setUsers(formattedUsers);
            setHistory(formattedHistory);
            setCompanyInfo(companysData);
            setState(userData.is_blocked);
        } catch (error: any) {
            console.log("error");
        }
    };



    const handleRepeatLastPlan = async (id: string) => {

        try {
            const response = await axiosInstance.post(`${backendbaseUrl}/company/plan-re-purchase/${id}/repeat/`);

            if (response.status === 201 || 200) {
                toast.success(response.data.message || 'Plan repurchased.');
                setUpdatesuggestions(updatesuggestion + 1)
            } else {
                toast.error(response.data?.error || 'Unable to repurchase plan.');
            }

        } catch (error: any) {
            const errMsg = error.response?.data?.error || 'Something went wrong.';
            toast.error(errMsg);
            console.error(error);
        }
    };


    const [companyDetailsData, SetcompanyDetailsData] = useState<CompanyDetailsData | null>(null)
    const CompanyDetailsApi = async () => {

        try {
            const response = await axiosInstance.get(
                `${backendbaseUrl}/company/company-profile-details/${id}`
            );

            const data = response.data
            SetcompanyDetailsData(data)


        }

        catch {
            toast.error("error loading company details")
        }
    }


    const [planDetails, setPlanDetails] = useState<PlanDetails | null>(null)
    const [apps, setAppsDetails] = useState<AppsDetails | null>(null)


    const planDetailsApi = async () => {

        try {
            const response = await axiosInstance.get(
                `${backendbaseUrl}/company/company-profile/plan-details/${id}`
            );

            const data = response.data.plan_details
            const apps = response.data.apps
            console.log("api data", apps)
            setPlanDetails(data)
            setAppsDetails(apps)


        }

        catch {
            toast.error("error loading company details")
        }
    }
    useEffect(() => {


        planDetailsApi()


    }, [updatesuggestion, id])


    useEffect(() => {
        CompanyDetailsApi()
    }, [])

    useEffect(() => {
        checkPaymentStatus();
    }, []);

    const getNextDate = (dateStr: string) => {
        const [day, month, year] = dateStr.split("-").map(Number);
        const date = new Date(year, month - 1, day + 1);
        return [
            String(date.getDate()).padStart(2, "0"),
            String(date.getMonth() + 1).padStart(2, "0"),
            date.getFullYear(),
        ].join("-");
    };

    const formatDate = (timestamp: number) => {
        return new Date(timestamp * 1000).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    const [buttonProceed, DisableButtonProceed] = useState<boolean>(false)




    const onProceed = async () => {


        try {
            const response = await axiosInstance.post(
                `${backendbaseUrl}/company/user-upgrade/${id}/custom-user-confirm/`, {
                "user_count": toNumber(usersCountParams)
            }
            );

            if (response.status === 201 || 200) {
                planDetailsApi()
                DisableButtonProceed(true)
                toast.success("Successfully Upgraded Users")

            }



        }

        catch {
            toast.error("error loading company details")
        }

    }


    return (
        <div className="page-body">
            <Container fluid>
                <div className="companyProfileWrapper">
                    <Row>
                        <Col md={3} className="position-relative">
                            <div className="sticky-top" style={{ top: "20px", zIndex: 100 }}>
                                <ItemWrapper>
                                    <div className="card p-4 shadow-sm rounded-4">
                                        <h5 className="text-primary fw-bold mb-4">Company Profile Details</h5>

                                        <ul className="list-unstyled">

                                            <li className="mb-3 d-flex align-items-center gap-3">
                                                <FaEnvelope className="text-primary fs-5" />
                                                <div>
                                                    <label className="text-muted small mb-1 d-block">Company Name</label>
                                                    <span className="fw-semibold text-dark">{companyDetailsData?.name || "N/A"}</span>
                                                </div>
                                            </li>

                                            <li className="mb-3 d-flex align-items-center gap-3">
                                                <FaEnvelope className="text-primary fs-5" />
                                                <div>
                                                    <label className="text-muted small mb-1 d-block">Email Address</label>
                                                    <span className="fw-semibold text-dark">{companyDetailsData?.email || "N/A"}</span>
                                                </div>
                                            </li>

                                            <li className="mb-3 d-flex align-items-center gap-3">
                                                <FaPhoneAlt className="text-success fs-5" />
                                                <div>
                                                    <label className="text-muted small mb-1 d-block">Phone Number</label>
                                                    <span className="fw-semibold text-dark">{companyDetailsData?.phone_number || "N/A"}</span>
                                                </div>
                                            </li>

                                            <li className="mb-3 d-flex align-items-center gap-3">
                                                <FaCalendarAlt className="text-purple fs-5" />
                                                <div>
                                                    <label className="text-muted small mb-1 d-block">Onboarded Date</label>
                                                    <span className="fw-semibold text-dark">{companyDetailsData?.created_at ? formatDate(companyDetailsData.created_at) : "N/A"}
                                                    </span>
                                                </div>
                                            </li>
                                            {/* 
                                            <li className="mb-3 d-flex align-items-center gap-3">
                                                <FaShieldAlt className="text-info fs-5" />
                                                <div className="d-flex justify-content-between align-items-center w-100">
                                                    <div>
                                                        <label className="text-muted small mb-1 d-block">Account Status</label>
                                                        <span className={`badge rounded-pill ${companyInfo.is_blocked ? 'bg-danger' : 'bg-success'}`}>
                                                            {companyInfo.is_blocked ? "Blocked" : "Active"}
                                                        </span>
                                                    </div>
                                                    <div className="form-check form-switch ms-auto">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            role="switch"
                                                            id="statusSwitch"
                                                            checked={!companyInfo.is_blocked}
                                                            onClick={blockedHandler}
                                                            onChange={(e) =>
                                                                setCompanyInfo({
                                                                    ...companyInfo,
                                                                    is_blocked: !e.target.checked,
                                                                })
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </li> */}
                                        </ul>
                                        {/* 
                                        <div className="d-flex flex-column gap-3 mt-4">
                                            <button
                                                className="btn btn-gradient-primary d-flex align-items-center justify-content-center gap-2"
                                                onClick={() => navigate(`/settings/company/upgrade-plan/${companyInfo.companyId}`)}
                                            >
                                                <FaBolt /> Upgrade Plan
                                            </button>

                                            <button className="btn btn-outline-dark d-flex align-items-center justify-content-center gap-2">
                                                <FaUserPlus /> Upgrade Users
                                            </button>
                                        </div>

                                        <div className="mt-4 text-center text-muted small">
                                            Company ID: <code>{companyInfo.companyId}</code>
                                        </div> */}
                                    </div>
                                </ItemWrapper>
                            </div>
                        </Col>
                        <Col md={9}>


                            {/* Current Plan Section */}

                            <Row className="mb-4">
                                <Col>
                                    <Card className="border-0 shadow-sm">
                                        <Card.Body>
                                            <div className="d-flex justify-content-between align-items-start mb-4">
                                                <div>
                                                    <h3 className="text-dark mb-1">🧾 Your Current Plan</h3>
                                                    <p className="text-muted">Overview of your subscription</p>
                                                </div>
                                                {renderStatusBadge(planDetails?.is_plan_active ?? false)
                                                }
                                            </div>

                                            <Row>
                                                <Col md={6}>
                                                    <div className="bg-white p-4 rounded shadow-sm border h-100">
                                                        <h5 className="mb-4 text-dark fw-semibold d-flex align-items-center">
                                                            <i className="bi bi-journal-text text-primary me-2"></i> Plan Overview
                                                        </h5>

                                                        <div className="mb-3 d-flex">
                                                            <i className="bi bi-card-heading text-muted me-2 mt-1"></i>
                                                            <div>
                                                                <small className="text-muted">Plan Name</small>
                                                                <div className="fw-bold text-dark">{planDetails?.plan.name}</div>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 d-flex">
                                                            <i className="bi bi-clock-history text-muted me-2 mt-1"></i>
                                                            <div>
                                                                <small className="text-muted">Duration</small>
                                                                <div className="text-dark">{planDetails?.plan.days} days</div>
                                                            </div>
                                                        </div>

                                                        <div className="mb-3 d-flex">
                                                            <i className="bi bi-people text-muted me-2 mt-1"></i>

                                                            {buttonProceed ?
                                                                <div>
                                                                    <small className="text-muted">Upgraded</small>
                                                                    <span className="badge bg-success bg-opacity-25 text-success px-3 py-2 fw-bold shadow-sm" style={{ fontSize: '1.2rem', border: '1px solid #198754', boxShadow: '0 0 10px rgba(25,135,84,0.5)' }}>
                                                                        {planDetails?.plan.max_users} Users
                                                                    </span>
                                                                </div> : <div>
                                                                    <small className="text-muted">Users Allowed</small>
                                                                    <div className="text-dark">{planDetails?.plan.max_users} users</div>
                                                                </div>}


                                                        </div>

                                                        <div className="mb-3 d-flex">
                                                            <i className="bi bi-list-check text-muted me-2 mt-1"></i>
                                                            <div>
                                                                <small className="text-muted">Included Features</small>
                                                                <ul className="list-unstyled mb-0">
                                                                    {(apps?.selected_apps?.length ?? 0) > 0 ? (
                                                                        apps?.selected_apps.map((feature, index) => (
                                                                            <li key={index} className="text-dark">• {feature}</li>
                                                                        ))
                                                                    ) : (
                                                                        <li className="text-muted">No features listed</li>
                                                                    )}
                                                                </ul>
                                                            </div>
                                                        </div>

                                                        <div className="mb-0 d-flex">
                                                            <i className="bi bi-calendar3 text-muted me-2 mt-1"></i>
                                                            <div>
                                                                <small className="text-muted">Timeline</small>
                                                                <div className="text-dark">Purchased: <strong>{planDetails?.purchase_date}</strong></div>
                                                                <div className="text-dark">Expires: <strong>{planDetails?.expiry_date}</strong></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>


                                                <Col md={6}>
                                                    <div className="bg-light p-4 rounded border shadow-sm">
                                                        <h5 className="mb-4 fw-semibold text-dark">💰 Cost Summary</h5>
                                                        <Table borderless size="sm">
                                                            <tbody>
                                                                <tr>
                                                                    <td className="text-muted">Days Left</td>
                                                                    <td className="text-end fw-bold text-dark">{pricingResponseData?.data?.remaining_days} days</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-muted">Extra Users</td>
                                                                    <td className="text-end fw-bold text-success">
                                                                        {planDetails?.plan.max_users} + {usersCountParams}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-muted">Cost per User</td>
                                                                    <td className="text-end">{pricingResponseData?.data.single_user_cost} {pricingResponseData?.data.currency}</td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="text-muted">Per Day / User</td>
                                                                    <td className="text-end">{pricingResponseData?.data.single_user_per_day_cost} {pricingResponseData?.data.currency}</td>
                                                                </tr>
                                                                <tr className="border-top">
                                                                    <td className="fw-semibold text-success">Amount Due</td>
                                                                    <td className="fw-bold text-success text-end">{pricingResponseData?.data.total_cost} {pricingResponseData?.data.currency}</td>
                                                                </tr>
                                                            </tbody>
                                                        </Table>

                                                        <div className="text-end mt-4">
                                                            <Button disabled={buttonProceed} color="success" className="px-4 py-2 fs-6" onClick={onProceed}>
                                                                🔐 Confirm & Proceed
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>



                            {/* 
                            <Row>
                                <Col>
                                    <Card className="border-0 shadow-sm">
                                        <Card.Body>
                                            <h4 className="mb-3 text-danger">Downgrade  Plan</h4>
                                            <p className="text-muted mb-4">Choose a plan that fits  organization's needs</p>

                                            <Row>


                                                {plansuggestions?.recommendations?.downgrade_plans.map((plan) => (
                                                    <Col key={plan.id} md={4} className="mb-3 mb-md-0">
                                                        <Card className="h-100">
                                                            <Card.Body className="d-flex flex-column">
                                                                <div className="mb-3">
                                                                    <h5>{plan.name}</h5>
                                                                    <h3 className="text-primary">Price : {plan.price} /{plan.days} days</h3>
                                                                    <small className="text-muted"> Description :{plan.description}</small>
                                                                    <br></br>
                                                                    <small className="text-muted">Duration :{plan.days}</small>
                                                                    <br></br>
                                                                    <small className="text-muted">Users :{plan.max_users}</small>
                                                                </div>

                                                                <ul className="mb-4 flex-grow-1">
                                                                    {plan.selected_apps.map((feature, index) => (
                                                                        <li key={index} className="mb-2 d-flex align-items-start">
                                                                            <span className="me-2 text-success">✓</span>
                                                                            <span>{feature}</span>
                                                                        </li>
                                                                    ))}
                                                                </ul>

                                                                <Button
                                                                    variant="primary"
                                                                    className="mt-auto d-flex align-items-center justify-content-center gap-2"
                                                                    onClick={() => handleUpgradeClick(plan.id)}
                                                                >
                                                                    <ArrowUpCircle size={18} />
                                                                    downgrade to {plan.name}
                                                                </Button>
                                                            </Card.Body>
                                                        </Card>
                                                    </Col>
                                                ))}
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row> */}



                            {/* Additional Information */}
                            <Row className="mt-4">
                                {/* <Col>
                                    <Card className="border-0 shadow-sm">
                                        <Card.Body>
                                            <h5 className="mb-3">Frequently Asked Questions</h5>
                                            <div className="accordion" id="planFAQ">
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
                                                            When will my plan be upgraded?
                                                        </button>
                                                    </h2>
                                                    <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#planFAQ">
                                                        <div className="accordion-body">
                                                            Your plan will be upgraded immediately after payment confirmation. Any unused time from your previous plan will be prorated and credited to your account.
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
                                                            Can I downgrade my plan later?
                                                        </button>
                                                    </h2>
                                                    <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#planFAQ">
                                                        <div className="accordion-body">
                                                            Yes, you can downgrade at any time. Downgrades will take effect at the end of your current billing cycle.
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="accordion-item">
                                                    <h2 className="accordion-header">
                                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
                                                            What happens if I exceed my user limit?
                                                        </button>
                                                    </h2>
                                                    <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#planFAQ">
                                                        <div className="accordion-body">
                                                            If you exceed your user limit, additional users won't be able to access the system until you either upgrade your plan or remove some users. We'll notify you when you reach 80% of your limit.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col> */}
                            </Row>
                        </Col>
                    </Row>
                </div>
            </Container>


        </div>
    );
};

export default CompanyUserUpgrade;
